import { render, staticRenderFns } from "./SubFolderDocumentAi.vue?vue&type=template&id=41f2b3a2&scoped=true&"
import script from "./SubFolderDocumentAi.vue?vue&type=script&lang=js&"
export * from "./SubFolderDocumentAi.vue?vue&type=script&lang=js&"
import style0 from "./SubFolderDocumentAi.vue?vue&type=style&index=0&id=41f2b3a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f2b3a2",
  null
  
)

export default component.exports